/* eslint-disable react/require-default-props */
import React from 'react';
import {TouchableOpacity, View} from 'react-native';
import {get} from 'lodash';

import Text from '/component/base/Text';
import {Reports} from '/constant/TestIDs';
import {withTranslation} from '/provider/TranslationProvider';
import {generateComponentCallback} from '/util/component.util';
import {getDateUtilDefaultInstance} from '/util/date.util';
import testProperties from '/util/testing/testProperties';

interface CandidateItem {
  createdTs?: string;
  source?: string;
}

interface CandidateDateAddedProps {
  tt: (key: string, params?: Record<string, any>) => string;
  item: CandidateItem;
  onPress?: () => void;
}

export const CandidateDateAdded = ({
  tt,
  item,
  onPress,
}: CandidateDateAddedProps) => {
  const createdTs = get(item, 'createdTs', '');
  const source = get(item, 'source', '');

  const formattedDate = getDateUtilDefaultInstance().formatDate(
    createdTs,
    'MMMM d, yyyy',
  );

  const dateText = tt('dateAdded', {
    date: formattedDate,
  });

  // Create a clear accessibility label
  const accessibilityLabel = `${dateText}${source ? `, ${source}` : ''}`;

  const component = (
    <View>
      <Text {...testProperties(Reports.reportCandidateDateAdded)}>
        {dateText}
      </Text>
      {!!source && <Text {...testProperties('sourceLabel')}>{source}</Text>}
    </View>
  );

  if (onPress) {
    return (
      <TouchableOpacity
        onPress={onPress}
        accessible={true}
        accessibilityRole="button"
        accessibilityLabel={accessibilityLabel}
        accessibilityHint="Double tap to view details">
        <View accessible={false}>{component}</View>
      </TouchableOpacity>
    );
  }

  return (
    <View
      accessible={true}
      accessibilityRole="text"
      accessibilityLabel={accessibilityLabel}>
      <View accessible={false}>{component}</View>
    </View>
  );
};

export default withTranslation('report.record.CandidateDateAdded')(
  generateComponentCallback(CandidateDateAdded),
);
